export default __webpack_public_path__ + "static/media/Onboarding1.24d6c1e9.png";